import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import Segment from '../../interfaces/segment';
import segmentColumnDef from '../../colDef/segmentColumnDef';
import { RootState } from '../../store/store';
import HandleSegmentModal from '../modals/handleSegmentModal';
import HandleSegmentUsersModal from '../modals/handleSegmentUsersModal';
import { GridRowSelectionModel } from '@mui/x-data-grid';

export const modalTypes: { [key: string]: string } = {
    SEGMENT_CREATE: 'segment_create',
    SEGMENT_EDIT: 'segment_edit',
    USER_ADD: 'user_add',
    USER_REMOVE: 'user_remove'
};

const ManageSegment = () => {
    const segments: Segment[] = useSelector((state: RootState) => state.segments.segments);
    const [openSegmentModal, setOpenSegmentModal] = useState<boolean>(false);
    const [openUserModal, setOpenUserModal] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<Segment[]>([]);
    const [modalType, setModalType] = useState<string>(modalTypes.SEGMENT_CREATE);
    const handleCloseSegmentModal = () => setOpenSegmentModal(false);
    const handleCloseUsersModal = () => setOpenUserModal(false);

    const handleOpenModal = (type: string) => {
        setModalType(type);
        if (type === modalTypes.SEGMENT_CREATE || type === modalTypes.SEGMENT_EDIT) {
            setOpenSegmentModal(true);
        } else {
            setOpenUserModal(true);
        }
    };

    const handleSelectedRows = (ids: GridRowSelectionModel) => {
        setSelectedRows(segments.filter(val => Array.from(ids.ids).includes(val.segment_id)));
    };

    return (
        <Box m={2}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} marginY="10px">
                {selectedRows.length === 1 ? (
                    <>
                        <Button sx={{ mr: 1 }} variant="contained" onClick={() => handleOpenModal(modalTypes.USER_ADD)}>
                            Add User to Segment
                        </Button>
                        <Button sx={{ mr: 1 }} variant="contained" onClick={() => handleOpenModal(modalTypes.USER_EDIT)}>
                            Remove Segment Users
                        </Button>
                        <Button sx={{ mr: 1 }} variant="contained" onClick={() => handleOpenModal(modalTypes.SEGMENT_EDIT)}>
                            Edit Segment
                        </Button>
                    </>
                ) : null}
                <Button variant="contained" onClick={() => handleOpenModal(modalTypes.SEGMENT_CREATE)}>
                    Add Segment
                </Button>
            </Box>

            <SearchResultGrid
                height='80vh'
                getRowId={(row: Segment) => row.segment_id}
                results={segments}
                onSelectRow={handleSelectedRows}
                columns={segmentColumnDef}
            />

            {openSegmentModal && <HandleSegmentModal setSelectedRow={setSelectedRows} modalVisible={openSegmentModal} closeModal={handleCloseSegmentModal} modalType={modalType} selectedRow={selectedRows[0]} />}
            {openUserModal && <HandleSegmentUsersModal selectedSegmentId={selectedRows[0].segment_id} modalVisible={openUserModal} closeModal={handleCloseUsersModal} modalType={modalType} />}
        </Box>
    );
};

export default ManageSegment;